// extracted by mini-css-extract-plugin
export default {"button":"primaryCountButton_button__7GEjw","count":"primaryCountButton_count__-msnC","child":"primaryCountButton_child__gVMVk"};